export const heroData = {
  title: "First-Time Visitors",
  subtitle: "Even if it's your first helicopter tour, you can enjoy it with complete peace of mind. Here's everything you need to know in advance.",
  image:
    "https://readdy.ai/api/search-image?query=Modern%20helicopter%20on%20helipad%20during%20warm%20sunset%20with%20blue%20sky%2C%20clean%20and%20welcoming%20atmosphere%2C%20luxury%20aviation%20facility%2C%20editorial%20photography%20style%2C%20no%20text%2C%20high%20quality&width=1920&height=600&seq=fthero01&orientation=landscape",
};

export const stepsData = {
  label: "STEP",
  title: "Three Steps to a Special Experience",
  steps: [
    {
      num: "01",
      icon: "ri-computer-line",
      title: "Easy Online Inquiry",
      desc: "Simply enter your preferred date, time, number of guests, and purpose. Our dedicated staff will suggest the best plan.",
      details: ["Available 24 hours a day", "Response within the next business day", "Compare multiple plans"],
    },
    {
      num: "02",
      icon: "ri-suitcase-line",
      title: "Pre-Departure Preparation",
      desc: "We provide guidance on attire, what to bring, and the day-of schedule. Feel free to ask us anything at any time.",
      details: ["Attire guide sent in advance", "Packing checklist", "Helipad access guide"],
    },
    {
      num: "03",
      icon: "ri-flight-takeoff-line",
      title: "Your Special Experience",
      desc: "After check-in at the helipad, you will take off with the pilot — and breathtaking scenery unfolds before you.",
      details: ["Check-in & safety briefing", "Pilot introduction", "Commemorative photo (optional)"],
    },
  ],
};

export const whatToWear = {
  label: "WHAT TO WEAR",
  title: "What to Wear",
  content: [
    {
      title: "Recommended Attire",
      items: ["Comfortable everyday clothing", "A jacket or cardigan (something to layer at the helipad or in the cabin)", "Stable footwear (avoid very thin heels)"],
    },
    {
      title: "Attire to Avoid",
      items: ["Skirts that may blow up in the wind (especially miniskirts)", "Stilettos or sandals", "Hats (may be blown off by the wind)"],
    },
  ],
};

export const whatToBring = {
  label: "WHAT TO BRING",
  title: "What to Bring",
  content: [
    {
      title: "Useful Items to Bring",
      items: ["Photo ID (driver's license, passport, etc.)", "Camera or smartphone", "Sunscreen & sunglasses (for daytime courses)"],
    },
    {
      title: "Items Not Permitted in the Cabin",
      items: ["Tripods & selfie sticks", "Bags (will be stored at check-in)", "Food & beverages", "Hazardous or flammable items"],
    },
  ],
};

export const worriesData = {
  label: "WORRIES",
  title: "Common Concerns — Answered",
  items: [
    {
      q: "Isn't it scary?",
      a: "Most of our guests are first-timers. The engine noise and floating sensation may surprise you at first, but you will get used to it within a few minutes. The pilot is always there to reassure you.",
    },
    {
      q: "Will it be bumpy?",
      a: "There may be slight turbulence due to air currents, but it is within the safe range — similar to any other aircraft. Flights are cancelled if weather conditions are poor.",
    },
    {
      q: "Can people with wheelchairs or mobility issues fly?",
      a: "It depends on the situation. Please contact us in advance and we will do our best to accommodate you.",
    },
    {
      q: "Can children fly?",
      a: "Children aged 3 and above may fly. However, infants must be accompanied by a parent or guardian. Please contact us for details.",
    },
    {
      q: "I get motion sick easily — will I be okay?",
      a: "Flight duration is approximately 15–40 minutes with minimal turbulence, so many people who experience car sickness find it manageable. If you are concerned, we recommend taking motion sickness medication in advance.",
    },
    {
      q: "Can I take photos?",
      a: "Yes, photos with a smartphone or camera are allowed. Please be careful of vibration inside the cabin and avoid hitting the windows.",
    },
  ],
};

export const finalCTA = {
  title: "Just bring your excitement —\nwe'll handle the rest",
  subtitle: "Because it's your first time, we will support you every step of the way",
  ctas: [
    { label: "Inquire About Booking", href: "/contact", type: "primary" },
    { label: "View FAQ", href: "/faq", type: "secondary" },
  ],
};
